import { LinkProps } from '@tanstack/react-router';
import { promisefy } from './promisefy';
import { DialogInfo } from '../types/obs';
import { ensureOBSPresence } from './ensureOBSPresence';

interface NavigateInModalProps
  extends LinkProps,
    Pick<DialogInfo, 'incognitoMode' | 'width' | 'height' | 'title' | 'isResizable'> {}

export async function navigateInModal<T = unknown>(props: NavigateInModalProps) {
  await ensureOBSPresence();
   
  const url = new URL(props.to as string, window.location.origin);
  const params = (props.params || {}) as Record<string, string>;

  const pathname = url.pathname
    .split('/')
    .map((piece) => {
      if (piece.startsWith('$')) {
        return params?.[piece.replace('$', '')];
      }

      return piece;
    })
    .join('/');

  url.pathname = pathname;

  for (const [key, value] of Object.entries(props?.search || {})) {
    url.searchParams.set(key, `${value}`);
  }

  const maxHeight = Math.floor(screen.availHeight * 0.8);
  const maxWidth = Math.floor(screen.availWidth * 0.8);

  return await promisefy(window.host.showModalDialog<T>)({
    url: url.toString(),
    width: Math.min(props.width ?? 610, maxWidth),
    height: Math.min(props.height ?? 835, maxHeight),
    incognitoMode: props.incognitoMode ?? false,
    title: props.title,
    isResizable: props.isResizable ?? true,
    executeJavaScriptOnLoad: `
      window.__streamelements_channel = ${JSON.stringify(window.__streamelements_channel)};
    `,
  });
}
